
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrepreneur/franchise-proposal",
      function () {
        return require("private-next-pages/entrepreneur/franchise-proposal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entrepreneur/franchise-proposal"])
      });
    }
  